import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmFaceterError extends TmBaseError {
  public name = 'TmFaceterError'
}
